import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { MatFabButton } from '@angular/material/button';
import {
    animate,
    keyframes,
    query,
    stagger,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';


@Component({
    selector: 'app-fab-expand',
    imports: [
    MatFabButton,
    SharedModule
],
    templateUrl: './fab-expand.component.html',
    styleUrl: './fab-expand.component.scss',
    animations: [
        trigger('toggle', [
            state('inactive', style({
                transform: 'rotate(0deg)'
            })),
            state('active', style({
                transform: 'rotate(225deg)'
            })),
            transition('* <=> *', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        trigger('speedDialStagger', [
            transition('* => *', [
                query(':enter', style({ opacity: 0 }), { optional: true }),
                query(':enter', stagger('40ms', [
                    animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', keyframes([
                        style({ opacity: 0, transform: 'translateY(10px)' }),
                        style({ opacity: 1, transform: 'translateY(0)' }),
                    ]))
                ]), { optional: true }),
                query(':leave', animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', keyframes([
                    style({ opacity: 1 }),
                    style({ opacity: 0 }),
                ])), { optional: true })
            ])
        ])
    ]
})
export class FabExpandComponent {

    @Input()
    set busy(b: boolean) { this.localBusy = b; if (b) { this.toggleState = false; }}
    get busy(): boolean { return this.localBusy; }
    private localBusy = false;

    @Output()
    opening = new EventEmitter<void>();

    @Output()
    closing = new EventEmitter<void>();

    toggleState = false;

    toggleExpand(): void {
        if (!this.busy) {
            this.toggleState = !this.toggleState;
            if (this.toggleState) {
                this.opening.emit();
            } else {
                this.closing.emit();
            }
        }
    }

}
